import { defaultsConfig } from "~config/sport/defaults";
import { tennisUi } from "~config/sport/tennisUi.ts";
import { CompetitorTypes } from "~enums/competitorTypes";
import type { SportConfiguration } from "~types/sportConfiguration";

export const tennisConfig: SportConfiguration = {
  ...defaultsConfig,
  competitorType: CompetitorTypes.Person,
  maxParticipantCount: 2,
  uiConfiguration: tennisUi,
};
